const SvgShutdown = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <path
      d="M13.333 0h-2.666v13.333h2.666V0zm6.438 2.896L17.88 4.788A9.234 9.234 0 0 1 21.335 12 9.328 9.328 0 0 1 12 21.335 9.328 9.328 0 0 1 2.665 12a9.307 9.307 0 0 1 3.439-7.229l-1.88-1.88C1.637 5.093 0 8.347 0 12c0 6.629 5.371 12 12 12s12-5.371 12-12c0-3.652-1.638-6.906-4.229-9.104z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgShutdown
